export default __webpack_public_path__ + "static/media/bronce.71dbc5da.png";